<div class="modal-component small">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text">
                {{data.header}}
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container justify-center">
        <div class="text-xl text-center">
            {{data.text}}
        </div>
    </div>
    <div class="modal-button-container">
        <button type="button" class="btn quaternary-button" (click)="onClose()">Nein</button>
        <button type="button" class="btn primary-button" (click)="onSubmit()">Ja</button>

    </div>
</div>
